export default "__VITE_ASSET__CCqDlgE7__"